import { motion } from 'framer-motion';
import Link from 'next/link';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { SettingMenu } from '@/components/GlobalSetting';
import PanelSettingDialog from '@/components/GlobalSetting/PanelSettingDialog';
import { LINK_DOCS_EN } from '@/configs/link';
import { PATH_TERMS } from '@/configs/path';
import useEnv from '@/hooks/useEnv';
import { eventDocsClick, eventPolicyClick } from '@/libs/gtag';
import { CurrencyId } from '@/types/Currency';
import { FlexBox } from '../atom/FlexBox';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow-y: auto;

  span {
    opacity: 0.4;
  }
`;

const FooterWrapper = styled(FlexBox)`
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;

  font-size: 16px;

  border-top: 1px solid rgba(129, 141, 166, 0.4);
  border-bottom: 1px solid rgba(129, 141, 166, 0.4);
`;

const PanelTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: ${(p) => p.theme.colors.textWhite};
  opacity: 0.4;
`;

interface Props {
  subPanel: React.Dispatch<React.SetStateAction<string>>;
  currency: CurrencyId;
  handleModal: (mode: boolean) => void;
}

export default function HeaderMenuPanel(props: Props) {
  const { isTestnet } = useEnv();

  const [, setMenu] = useState<SettingMenu>('');

  const handleDocsClick = useCallback(
    () => eventDocsClick(isTestnet),
    [isTestnet]
  );
  const handlePolicyClick = useCallback(
    () => eventPolicyClick(isTestnet),
    [isTestnet]
  );
  const handleMenuClick = useCallback(
    (menu: SettingMenu) => () => {
      setMenu(menu);
      props.subPanel(menu);
    },
    [props]
  );

  return (
    <Wrapper
      as={motion.div}
      initial={{
        x: '-100%',
      }}
      animate={{
        x: 0,
      }}
      exit={{
        x: '-100%',
      }}
    >
      <FlexBox $flex $direction="column" $gap="xxs">
        <PanelTitle>Setting</PanelTitle>
        <PanelSettingDialog
          isShow
          currency={props.currency}
          onMenuClick={handleMenuClick}
        />
      </FlexBox>
      <FlexBox $flex $direction="column" $gap="xl">
        <FooterWrapper $flex $gap="md" $direction="column">
          <a target="_blank" href={LINK_DOCS_EN} onClick={handleDocsClick}>
            Docs
          </a>
          <Link href={PATH_TERMS} onClick={handlePolicyClick}>
            Privacy Policy & Terms of Use
          </Link>
        </FooterWrapper>
        <span>&copy; 2024 Bifrosoft PTE LTD</span>
      </FlexBox>
    </Wrapper>
  );
}
